import { mapGetters, mapActions } from 'vuex'

import Logo from '@/assets/longball-logo-small.svg'

export default {
  name: 'PrivatePageWrapper',
  props: {
    title: String,
    tabsArr: Array
  },
  data: () => ({
    Logo,
    isExtended: false,
    bottomNav: 'dashboard'
  }),
  computed: {
    ...mapGetters([
      'PAGE_TITLE',
      'HEADER_TABS',
      'HEADER_EDIT',
      'INVITE_COUNT',
      'HAS_MAX_WIDTH',
      'IMAGE_BACKGROUND',
      'SHOW_BOTTOM_NAV',
      'SHOW_BACK_BUTTON',
      'SHOW_SELECT_BUTTON',
      'SHOW_CANCEL_BUTTON',
      'SHOW_LOGO'
    ]),
    ...mapGetters('auth', {
      isAdmin: 'IS_ADMIN'
    }),
    ...mapGetters('admin', {
      selectToggle: 'GET_SELECT_TOGGLE'
    }),

    btnDashboardClass() {
      return `material-icons${
        this.PAGE_TITLE === 'dashboard' ? '' : this.isIE() ? '' : '-outlined'
      }`
    },
    btnLeagueClass() {
      return `material-icons${
        this.PAGE_TITLE === 'premier league'
          ? ''
          : this.isIE()
          ? ''
          : '-outlined'
      }`
    },
    btnProfileClass() {
      return `material-icons${
        this.PAGE_TITLE === 'profile' ? '' : this.isIE() ? '' : '-outlined'
      }`
    },
    btnSettingsClass() {
      return `material-icons${
        this.PAGE_TITLE === 'settings' ? '' : this.isIE() ? '' : '-outlined'
      }`
    }
  },
  methods: {
    ...mapActions({
      getInviteCount: 'FETCH_INVITE_COUNT'
    }),
    ...mapActions('admin', {
      toggleSelect: 'TOGGLE_SELECT'
    }),
    isHiddenWhenAdmin(bool) {
      if (this.isAdmin) {
        return this.isAdmin && !bool
      }
      return true
    },
    isHiddenWhenUser(bool) {
      if (!this.isAdmin) {
        return !this.isAdmin && !bool
      }
      return true
    },
    isIE() {
      const ua = navigator.userAgent
      /* MSIE used to detect old browsers and Trident used to newer ones*/
      return ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1
    },
    goBack() {
      const currentRoute = this.$router.currentRoute.path
      if (currentRoute.includes('user-prediction')) {
        this.$router.push({ name: 'leaderboard-group' })
      } else {
        this.$router.go(-1)
      }
    },
    selectClick() {
      if (this.selectToggle) {
        this.$store.commit('admin/SET_TRIGGER_MOVE_BUTTON', true)
      } else {
        this.toggleSelect(true)
        this.$store.commit('SET_SHOW_SELECT_BUTTON', {
          show: true,
          label: 'Move'
        })
        this.$store.commit('SET_SHOW_CANCEL_BUTTON', true)
      }
    },
    cancelClick() {
      this.toggleSelect(false)
      this.$store.commit('SET_SHOW_SELECT_BUTTON', {
        show: true,
        label: 'Select'
      })
      this.$store.commit('SET_SHOW_CANCEL_BUTTON', false)
    }
  },
  watch: {
    HEADER_TABS: {
      handler(data) {
        this.isExtended = data ? true : false
      },
      immediate: true
    },
    PAGE_TITLE: {
      handler(data) {
        this.bottomNav = data || 'dashboard'
      },
      immediate: true
    }
  },
  activated() {
    this.getInviteCount()
  }
}
